import { request } from "../lib/http";

export function fetchAll() {
  return request({
    url: "rfid-reader-delay",
    method: "get",
  });
}
